import React from 'react';
import classNames from 'classnames';
import {useCreateShumaContext} from '../CreateShumaContext';
import EmptyView from '../../../../common/components/Empty';
import styles from './styles.module.scss';
import {useRouteMatch} from 'react-router-dom';
import {pathnames as P} from '../../../../common/constants/pathnames';
import {AddCustomerButton} from '../AddEditCustomer';
import {EditCustomerButton} from '../AddEditCustomer/EditCustomerButton';

const StepCustomersList = () => {
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);
  const {stepData: {customers, shumaTypeID}, onCustomerEdited} = useCreateShumaContext();
  const header = shumaTypeID === 1 ? 'לקוחות' : 'לווים';

  const renderCustomers = (item, index) => {
    const customerValue = [
      item.customerFirstName,
      item.customerLastName,
      item.customerIdNumber,
    ].filter(Boolean).join(' ');

    return (
      <div className={styles.listItem} key={index}>
        <input
          name={`customer_${item.customerID}`}
          className={styles.input}
          value={customerValue}
          disabled={true}
        />
        <div className={styles.editCustomerButtonContainer}>
          <EditCustomerButton shumaID={shumaId} customerID={item.customerID} onSuccess={onCustomerEdited}
                              customer={item}/>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.listContainer}>
      <div className={classNames(styles.headerContainer, styles.marginBottom25)}>
        <h3>{header}</h3>
        <AddCustomerButton shumaID={shumaId} onSuccess={onCustomerEdited}/>
      </div>
      {(customers && customers.length > 0)
        ? customers.map(renderCustomers)
        : <EmptyView message={'אין נתונים על לקוחות'}/>
      }
    </div>
  );
};

export default StepCustomersList;